import { GridItem, Link, List, ListItem, Text } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { ContentPanel } from "../../../components/content-panel";

export const WhatsNewBlock = () => {
  const intl = useIntl();

  return (
    <GridItem rowSpan={2}>
      <ContentPanel
        title={intl.formatMessage({
          id: "dashboard.whats_new",
          defaultMessage: "What's new?",
        })}
      >
        <List>
          <ListItem>
            <Text as="strong">
              <FormattedMessage
                id="dashboard.rana_training_center"
                defaultMessage="Rana Training Center"
              />
            </Text>
          </ListItem>
          <ListItem mb={3}>
            <div>
              <FormattedMessage
                id="dashboard.rana_training_center_intro"
                defaultMessage="Rana Hydrodynamics – Basis"
              />
            </div>
            <div>
              <Text as="strong">
                <FormattedMessage
                  id="dashboard.rana_training_center_date"
                  defaultMessage="7–8 December 2026 and 18 January 2027"
                />
              </Text>
            </div>
            <Link
              href="https://ranawaterintelligence.io/training-center/"
              target="_blank"
              rel="noreferrer"
              color="brand.clear_creek"
            >
              <FormattedMessage
                id="dashboard.rana_training_center_signup"
                defaultMessage="Sign up here"
              />
            </Link>
          </ListItem>
          <ListItem>
            <Text as="strong">
              <FormattedMessage
                id="dashboard.extended_export_options"
                defaultMessage="Extended export options"
              />
            </Text>
          </ListItem>
          <ListItem mb={3}>
            <FormattedMessage
              id="dashboard.extended_export_options_description"
              defaultMessage="When exporting a preview or publication, you now have more control over the end result. You can choose between file formats and export quality."
            />
          </ListItem>
          <ListItem>
            <Text as="strong">
              <FormattedMessage
                id="dashboard.vector_data_importer"
                defaultMessage="Vector data importer in the RDC"
              />
            </Text>
          </ListItem>
          <ListItem mb={3}>
            <FormattedMessage
              id="dashboard.vector_data_importer_description"
              defaultMessage="With the new Vector Data Importer in the RDC, setting up a computational model is easier and more efficient."
            />
          </ListItem>
        </List>
      </ContentPanel>
    </GridItem>
  );
};
